import { ArrowRightIcon } from "@phosphor-icons/react";

import { Tooltip, toastSuccess } from "@alpacahq/ui/old";

const SUPPORT_EMAIL = "support@alpaca.markets";

export const SupportLink = () => (
  <Tooltip content={<>Email {SUPPORT_EMAIL} to update this information.</>}>
    <button
      type="button"
      className="flex cursor-pointer items-center gap-2 border-none bg-transparent p-0 text-right text-blue-500 text-sm"
      onClick={() => {
        navigator.clipboard.writeText(SUPPORT_EMAIL);
        toastSuccess(`${SUPPORT_EMAIL} copied to clipboard`);
      }}
    >
      Want to update your info? <ArrowRightIcon />
    </button>
  </Tooltip>
);
